export function tryGetErrorMessage(e: unknown): string | undefined {
  if (!e || typeof e !== 'object') return undefined;

  if ('error' in e) {
    return tryGetErrorMessage((e as { error?: unknown }).error);
  }

  if ('data' in e) {
    const data = (e as { data?: unknown }).data;
    if (typeof data === 'string') return data;
    if (data && typeof data === 'object' && 'message' in data && typeof data.message === 'string') {
      return data.message;
    }
  }

  if ('message' in e && typeof (e as { message?: unknown }).message === 'string') {
    return (e as { message: string }).message;
  }

  return undefined;
}
